/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
// import _ from 'lodash';

import {
  REQUEST_TRANSPORT_ORDERS,
  REQUEST_TRANSPORT_ORDER,
  REQUEST_TRANSPORT_ORDER_FILTER,
  UPDATE_TRANSPORT_ORDER_SEARCH_STRING,
  UPDATE_TRANSPORT_ORDER_FILTERS,
  REQUEST_TRANSPORT_ORDER_FILTER_RESET,
  SET_TRANSPORT_ORDERS_SORT,
  APPLY_TRANSPORT_ORDER_FILTERS,
  INITIATE_TRANSPORT_ORDER_CREATE,
  INITIATE_TRANSPORT_ORDER_EDIT,
  SET_NEW_TRANSPORT_ORDER_VALUE,
  TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES,
  TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES,
  ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST,
  REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
  REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST,
  SWITCH_OVERVIEW_SCREEN_MODE,
  SET_FILTER_COMBINATION,
} from './constants';

import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { fixPriceFormat } from '../../utils/string';
import env from '../../env';
import { AppClientId } from '../Shared/constants';
import { parseTransportOrderVehicle, parseVehicle } from '../Vehicles/helpers';
import { parseTransportOrderModel } from './helpers';
import { parseCompany } from '../Companies/helpers';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  limit: 100,
  properties: [],
  sortType: null,
  order: null,
};

export const initialState = {
  transportOrders: [],
  transportOrdersSeparateList: [],
  transportOrdersByIdSeparateList: {},
  transportOrdersById: {},
  filter: {
    ...DEFAULT_FILTER,
  },
  separateListFilter: { ...DEFAULT_FILTER },
  filterCombination: null,
  separateFilterCombination: null,
  vehicleTransportOrders: [],
  newTransportOrder: {},
  doubleScreenOverview: null,

  transportOrderBulkActionsList: [],

  transportOrderCount: null,
  separateListTransportOrderCount: null,
  paginator: {},
  separateListPaginator: {},
  propertyNames: null,
};

export const transportOrderReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SWITCH_OVERVIEW_SCREEN_MODE:
        if (draft.doubleScreenOverview) {
          draft.doubleScreenOverview = null;
          return;
        }
        draft.doubleScreenOverview = true;
      case SET_NEW_TRANSPORT_ORDER_VALUE:
        if (action.initiate) {
          draft.newTransportOrder[action.name] = draft.newTransportOrder[action.name] || '';
        } else draft.newTransportOrder[action.name] = action.value;
        return;
      case INITIATE_TRANSPORT_ORDER_EDIT:
        try {
          draft.newTransportOrder = {
            id: action.id,
          };

          let transportOrder = draft.transportOrdersById[action.id];

          if (transportOrder) {
            Object.keys(transportOrder)?.forEach(p => {
              if (['id', 'companyToRead', 'companyFromRead', 'vehicleRead']?.includes(p)) return null;

              draft.newTransportOrder[p] = transportOrder[p];
              return null;
            });
          }
        } catch (e) {
          // eslint-disable-next-line no-debugger
          console.log(e);
        }
        break;
      case INITIATE_TRANSPORT_ORDER_CREATE:
        //only clear if there's an id
        draft.newTransportOrder = {};
        [...TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES, ...TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES]?.forEach(p => {
          draft.newTransportOrder[p] = '';
        });

        break;
      case SET_TRANSPORT_ORDERS_SORT:
        const targetFilter = action.separateFilter || action.separateList ? draft.separateListFilter : draft.filter;
        targetFilter.sortType = action.sortType;
        targetFilter.order = action.order;
        return;
      case UPDATE_TRANSPORT_ORDER_SEARCH_STRING:
        draft.filter.searchString = action.searchString || '';
        return;

      case SET_FILTER_COMBINATION:
        const quickFilter = action.separateFilter || action.separateList ? draft.separateListFilter : draft.filter;
        const quickFilterCombination =
          action.separateFilter || action.separateList ? 'separateFilterCombination' : 'filterCombination';
        if (action.combination === draft[quickFilterCombination]) {
          draft[quickFilterCombination] = null;
          quickFilter.properties = [];
          return;
        }
        quickFilter.properties = action.properties ?? [];
        draft[quickFilterCombination] = action.combination;

        break;
      case UPDATE_TRANSPORT_ORDER_FILTERS:
      case REQUEST_TRANSPORT_ORDER_FILTER:
        const filter = action.separateFilter || action.separateList ? draft.separateListFilter : draft.filter;
        if ('propertyFilter' in action) {
          if (action?.options?.skipFilter) {
            filter.properties = [];
            filter.properties.push(action.propertyFilter);
            return;
          }

          if (action?.getDeleted) {
            filter.getDeleted = true;
          } else {
            filter.getDeleted = false;
          }

          filter.properties = filter.properties
            .map(p => {
              if (p.key == action.propertyFilter?.key) return null;
              if (p.key == action.reset) return null;
              if (action.reset?.indexOf?.(p.key) > -1) {
                return null;
              }
              return p;
            })
            .filter(p => p);

          if (action.propertyFilter) filter.properties.push(action.propertyFilter);
        }

        //clear empty values
        filter.properties = filter.properties.filter(p => p.value.length || p.value.id);

        if (action.name) {
          filter[action.name] = action.value;
          //reset offset
        }

        if (action.name !== 'offset') filter.offset = 0;
        break;
      case REQUEST_TRANSPORT_ORDER_FILTER_RESET:
        if (action.separateFilter) {
          draft.separateListFilter = {
            ...DEFAULT_FILTER,
          };
          return;
        }
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        break;
      case ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST:
        if (action?.payload) {
          const isInList = draft.transportOrderBulkActionsList?.filter(item => item?.id == action.payload?.id);

          draft.transportOrderBulkActionsList = !isInList?.length
            ? [...draft.transportOrderBulkActionsList, action.payload]
            : draft.transportOrderBulkActionsList;
        }
        return;
      case REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST:
        if (action?.transportOrderId) {
          draft.transportOrderBulkActionsList = draft.transportOrderBulkActionsList.filter(
            item => item?.id != action?.transportOrderId,
          );
        }
        return;
      case REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST:
        draft.transportOrderBulkActionsList = [];
        return;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_TRANSPORT_ORDERS:
            if (action?.separateList) {
              draft.transportOrdersSeparateList = action.result.items?.map(transportOrder => {
                return {
                  ...transportOrder,
                  vehicle: parseTransportOrderModel(transportOrder?.vehicleRead),
                  companyFrom: parseTransportOrderModel(transportOrder?.companyFromRead),
                  companyTo: parseTransportOrderModel(transportOrder?.companyToRead),
                };
              });
              draft.separateListPaginator = action.result.paginator;
              draft.separateListTransportOrderCount = action.result.paginator.itemsCount;
              draft.transportOrdersSeparateList.forEach(o => {
                // if (!draft.transportOrdersById[o.id])
                // draft.transportOrdersByIdSeparateList[o.id] = o;
              });
              return;
            }
            draft.transportOrders = action.result.items?.map(transportOrder => {
              return {
                ...transportOrder,
                vehicle: parseTransportOrderModel(transportOrder?.vehicleRead),
                companyFrom: parseTransportOrderModel(transportOrder?.companyFromRead),
                companyTo: parseTransportOrderModel(transportOrder?.companyToRead),
              };
            });

            draft.paginator = action.result.paginator;
            draft.transportOrderCount = action.result.paginator.itemsCount;
            draft.transportOrders.forEach(o => {
              // if (!draft.transportOrdersById[o.id])
              draft.transportOrdersById[o.id] = o;
            });
            break;
          case REQUEST_TRANSPORT_ORDER:
            try {
              draft.transportOrdersById[action.transportOrderId] = {
                ...action.result,
                vehicle: parseVehicle(action.result.vehicle),
                companyFrom: parseCompany(action.result.companyFrom),
                companyTo: parseCompany(action.result.companyTo),
              };
              console.dir(action.result);
            } catch (e) {
              console.error(e);
            }

            break;
        }
        break;
    }
  });
